__turbopack_context__.v({
  "productItem": "kF07jW_productItem",
  "productList": "kF07jW_productList",
  "unavailableProductsList": "kF07jW_unavailableProductsList",
  "unavailableProductsTitle": "kF07jW_unavailableProductsTitle",
});
